import { Box, Text, Link } from '@everlywell/ui-kit';
import React from 'react';

type DisclaimerProps = {
  children: React.ReactNode;
};

export function Disclaimer({ children }: DisclaimerProps) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      alignSelf="stretch"
      borderRadius="12px"
      backgroundColor="tints.white"
      width={{ base: '345px', md: '670px' }}
      minHeight={{ base: '60px', md: '30px' }}
      paddingX={[3, 4]}
      paddingY={[2, 4]}
      gap={{ base: '10px', md: '0px' }}
    >
      <Text
        textAlign="center"
        color="tints.darkGrey"
        fontFamily="DM Sans"
        fontSize="xs"
        fontStyle="normal"
        fontWeight={400}
        lineHeight="150%"
        // mobile-only
        flex={{ base: '1 0 0', md: 'unset' }}
        sx={{ fontFeatureSettings: "'liga' off, 'clig' off" }}
      >
        {children}
      </Text>
    </Box>
  );
}

type LinkProps = React.PropsWithChildren<{
  href: string;
  target?: string;
  rel?: string;
}>;

export function DisclaimerLink({
  href,
  children,
  target = '_blank',
  rel = 'noreferrer noopener',
}: LinkProps) {
  return (
    <Link
      href={href}
      target={target}
      rel={rel}
      color="eggplant.base"
      fontFamily="DM Sans"
      fontSize="xs"
      textDecorationLine="underline"
      sx={{
        fontFeatureSettings: "'liga' off, 'clig' off",
        textDecorationStyle: 'solid',
        textDecorationSkipInk: 'none',
        textDecorationThickness: 'auto',
        textUnderlineOffset: 'auto',
        textUnderlinePosition: 'from-font',
      }}
    >
      {children}
    </Link>
  );
}

export default function ChatTermsDisclaimer(): JSX.Element {
  return (
    <Disclaimer>
      This chat is powered by AI and may provide general health information, but
      it doesn't provide medical advice. This chat may be monitored and recorded
      by us or our service providers. By continuing you agree to{' '}
      <DisclaimerLink href="/terms-of-use">Terms of Use</DisclaimerLink> and{' '}
      <DisclaimerLink href="/privacy-policy">Privacy Policy</DisclaimerLink>.
    </Disclaimer>
  );
}
